import React, { Component, Fragment } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import DynamicForm from '../../../../components/DynamicForm';
import { UPDATE_SETTING, GET_SETTING_BY_ID } from '../api';
import { editSettingFormFieldConfig } from '../utils';

export class EditSettingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      comment: '',
      gridRowData: this.props.data,
    };
  }

  _handleClose = () => this.setState({ show: false });

  _handleShow = () => this.setState({ show: true });

  _handleMutation = (formData, updateFunction) => {
    updateFunction({
      variables: {
        setting: formData,
      },
    });
  };

  _handleMutationComments = (formData, createCommentFn) => {
    createCommentFn({
      variables: {
        barcode: formData.barcode,
        verifyId: formData.verifyId,
        comment: formData.comment,
        createdBy: formData.createdBy,
        createdOn: formData.createdOn,
        lastUpdatedBy: formData.lastUpdatedBy,
        updatedOn: formData.updatedOn,
      },
    });
  };

  render() {
    return (
      <Fragment>
        <Button variant="primary" onClick={this._handleShow}>
          <i className="fa fa-edit"></i>
        </Button>
        <Modal show={this.state.show} onHide={this._handleClose} dialogClassName="modal-min-width">
          <Modal.Header closeButton>
            <Modal.Title>Edit Setting</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DynamicForm
              title=""
              smallTitle=""
              fieldModel={editSettingFormFieldConfig}
              getDataQuery={GET_SETTING_BY_ID}
              getDataResolverName="getSettingById"
              queryVars={{ id: this.state.gridRowData.settingId }}
              setDataMutation={UPDATE_SETTING}
              readOnly={false}
            />
          </Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps, {})(EditSettingModal);
